import SectionTitle from '../../components/SectionTitle';
import ImageSlider from '../../components/ImageSlider';

import style from './shakeGallery.module.css';
import useWindowSize from '../../hooks/useWindowSize';

const ShakeGallery = ({images}) => {
  const {width} = useWindowSize();
  return (
    <div>
      <div className={style.app__shake_gallery_title}>
        <SectionTitle
          title={`Gallery`}
          subtitle={`Shake Around The World`}/>
      </div>
      <ImageSlider
        images={images}
        imageHeight={width > 690 ? 600 : 400}
        showingNum={width > 690 ? 5 : 2}
        autoPlayDelay={10000}/>
    </div>
  );
};

export default ShakeGallery;
